import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
	TGetPublicAttachmentUploadInfoRequest,
	TPublicAttachmentStore,
	TPublicAttachmentUploadInfo,
	TUploadPublicAttachmentRequest,
} from './types';

export const initialState: TPublicAttachmentStore = {
	uploadInfo: null,
	uploadInfoLoading: false,
	uploadInfoError: null,
	uploadFileLoading: false,
	uploadSuccess: false,
};

const publicAttachment = createSlice({
	name: '@@publicAttachment',
	initialState,
	reducers: {
		getPublicAttachmentUploadInfoRequest: (
			state: TPublicAttachmentStore,
			action: PayloadAction<TGetPublicAttachmentUploadInfoRequest>,
		) => {
			state.uploadInfoLoading = true;
			state.uploadInfoError = null;
			state.uploadInfo = null;
			state.uploadSuccess = false;
		},
		getPublicAttachmentUploadInfoSuccess: (
			state: TPublicAttachmentStore,
			action: PayloadAction<TPublicAttachmentUploadInfo>,
		) => {
			state.uploadInfo = action.payload;
			state.uploadInfoLoading = false;
			state.uploadInfoError = null;
		},
		setPublicAttachmentUploadInfoError: (
			state: TPublicAttachmentStore,
			action: PayloadAction<string>,
		) => {
			state.uploadInfoError = action.payload;
			state.uploadInfoLoading = false;
			state.uploadInfo = null;
		},
		uploadPublicAttachmentRequest: (
			state: TPublicAttachmentStore,
			action: PayloadAction<TUploadPublicAttachmentRequest>,
		) => {
			state.uploadFileLoading = true;
			state.uploadSuccess = false;
		},
		uploadPublicAttachmentSuccess: (state: TPublicAttachmentStore) => {
			state.uploadFileLoading = false;
			state.uploadSuccess = true;
		},
		uploadPublicAttachmentFailure: (state: TPublicAttachmentStore) => {
			state.uploadFileLoading = false;
		},
		resetPublicAttachmentState: () => initialState,
	},
});

export default publicAttachment.reducer;
export const {
	getPublicAttachmentUploadInfoRequest,
	getPublicAttachmentUploadInfoSuccess,
	setPublicAttachmentUploadInfoError,
	uploadPublicAttachmentRequest,
	uploadPublicAttachmentSuccess,
	uploadPublicAttachmentFailure,
	resetPublicAttachmentState,
} = publicAttachment.actions;
